import { cn } from '@/lib/utils'

import { DocumentItem } from './document-item'
import { type DocumentData } from './types'
import { useDocumentList } from './use-document-list'

export interface DocumentsListProps {
  items: DocumentData[]
}

export const DocumentList = ({ items }: DocumentsListProps) => {
  const { handleClickDocumentItem } = useDocumentList()

  return (
    <div className={cn('flex flex-col gap-y-1.5', 'w-full')}>
      {items.map((item, index) => (
        <DocumentItem key={`${item.name}-${index}`} item={item} onClick={() => handleClickDocumentItem(item.taskId)} />
      ))}
    </div>
  )
}
